import { render, staticRenderFns } from "./SignsSection.vue?vue&type=template&id=027000ae&lang=pug&"
import script from "./SignsSection.vue?vue&type=script&lang=ts&"
export * from "./SignsSection.vue?vue&type=script&lang=ts&"
import style0 from "./SignsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports